import { SeoFilterModule } from 'filters/seo.filter';
import { StripHtmlFilterModule } from 'filters/stripHtml.filter';
import { ALLOWED_TAGS } from 'app/constants';

export const SeoHelperServiceModule = angular
    .module('app.services.utilities.seoHelperService', [
        SeoFilterModule,
        StripHtmlFilterModule
    ]).factory('seoHelperService', ($filter) => {
        let nameChanged = false;

        function shouldUpdateTitle(model) {
            if (!model.name) {
                return false;
            }

            let hasNameChanged = (nameChanged || model.hasChanges('name'));
            let hasTitleChanged = model.seo.hasChanges('title');
            let hasTitle = model.seo.title;

            return (hasNameChanged && !hasTitleChanged) || !hasTitle;
        }

        function shouldUpdateFriendlyName(model, state) {
            let hasName = model.seo.friendlyName;
            let hasChanges = model.seo.hasChanges('friendlyName');
            nameChanged = model.hasChanges('name');

            return !hasName || (hasName && !hasChanges && (state.add || nameChanged));
        }

        function fillDefaultValues(model, state, isPage = false) {
            if (shouldUpdateFriendlyName(model, state)) {
                model.seo.friendlyName = $filter('seoFilter')(model.name.substring(0, 255));
                model.seo.update('friendlyName');
            } else {
                model.seo.friendlyName = $filter('seoFilter')(model.seo.friendlyName);
            }

            if (shouldUpdateTitle(model)) {
                nameChanged = true;
                model.seo.title = model.name.substring(0, 60);
                model.seo.update('title');
            }

            if (model.seo.hasChanges('title')) {
                nameChanged = false;
            }

            if (isPage && !model.seo.metaDescription && model.content) {
                model.seo.metaDescription = $filter('stripHTML')(model.content.substring(0, 160));
                model.seo.metaDescription = model.seo.metaDescription.replace(/[\n\r]/g, ' ').trim();
                model.seo.update('metaDescription');
            }

            if (!isPage && !model.seo.metaDescription && model.descriptions.long) {
                model.seo.metaDescription = $filter('stripHTML')(model.descriptions.long).substring(0, 160);
                model.seo.update('metaDescription');
            }

            // category
            if (!isPage && !model.categoryIds && model.descriptions.long) {
                model.descriptions.long = $filter('stripHTML')(model.descriptions.long, ALLOWED_TAGS);
                model.descriptions.update('long');
            }

            // product
            if (!isPage && model.categoryIds && model.descriptions.long) {
                model.descriptions.long = $filter('stripHTML')(model.descriptions.long, ALLOWED_TAGS);
            }
        }

        return {
            fillDefaultValues: fillDefaultValues
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/seoHelper.service.js